<template>
    <div data-component="CartOffersTab"
         class="cart-offers-tab modl-tab-body">
        <div class="modl-body">
            <OfferSelector :initial-selected-offers="selectedOffers"
                           :offers="offers"
                           :allow-multiple="true"
                           @update:selected-offers="updateSelectedOffers"></OfferSelector>
        </div>
    </div>
</template>

<script>
import OfferSelector from '@/epos/vue/modals/CartOffers/OfferSelector';
import { mapState } from 'vuex';

export default {
    name: 'CartOffersTab',

    components: {
        OfferSelector,
    },

    props: {},

    data() {
        return {
            /**
             * @type {Offer[]}
             */
            offers: null,

            /**
             * @type {Object<number, number>}
             */
            selectedOffers: {},
        };
    },

    computed: {
        ...mapState('cartOffers', ['manualOrderOffers', 'selectedManualOrderOffers']),
    },

    async created() {
        this.selectedOffers = this.selectedManualOrderOffers;
        this.offers = this.manualOrderOffers;
    },

    methods: {
        updateSelectedOffers(newValue) {
            this.$store.commit('cartOffers/setSelectedManualOrderOffers', newValue);
        },
    },
};
</script>
